import request from '@/utils/request'
// 获取资讯信息列表-居民端
export function WeGetRealInfoPage(query) {
  return request({
    url: 'RealInfo/WeGetRealInfoPage',
    method: 'get',
    params: query,
  })
}
// 获取资讯信息-居民端
export function WeGetRealInfo(RIId) {
  return request({
    url: 'system/trealinfo/' + RIId,
    method: 'get',
  })
}
// 获取政务详情-居民端
export function GettactivityInfo(RIId) {
  return request({
    url: 'system/tactivity/' + RIId,
    method: 'get',
  })
}

// 移动端-获取社区活动分类信息列表
export function WxGetAKindList(query) {
  return request({
    url: 'system/tactkind/list',
    method: 'get',
    params: query,
  })
}
export function WeGetTactivityInfo(RIId) {
  return request({
    url: 'system/tactivity/' + RIId,
    method: 'get',
  })
}
// 小程序-获取社区活动分页列表
export function WeGetActivityPage(query) {
  return request({
    url: 'Activity/WeGetActivityPage',
    method: 'get',
    params: query,
  })
}
// 获取社区活动详情
export function WeGetActivityDetail(query) {
  return request({
    url: 'Activity/WeGetActivityDetail',
    method: 'get',
    params: query,
  })
}
// 居民端小程序-获取招募中的活动分页列表
export function WxGetRecruitActivityPage(query) {
  return request({
    url: 'system/tactivity/list',
    method: 'get',
    params: query,
  })
}
// 居民端小程序-获取活动详情
export function WxGetActivityDetail(AIds) {
  return request({
    url: 'system/tactivity/' + AIds,
    method: 'get',
  })
}
// 小程序-报名参与社区活动
export function WeEnrolActivity(data) {
  return request({
    url: 'Activity/WeEnrolActivity',
    method: 'post',
    data: data,
  })
}
// 小程序获取商铺分页列表
export function WeGetShopPage(query) {
  return request({
    url: 'Shop/WeGetShopPage',
    method: 'get',
    params: query,
  })
}
// 获取资讯信息列表-党员端
export function WeGetPartyInfoPage(query) {
  return request({
    url: 'PartyInfo/WeGetPartyInfoPage',
    method: 'get',
    params: query,
  })
}
// 获取党员积分分页列表[党员端]
export function WeGetPMIntegralPage(query) {
  return request({
    url: 'Party/WeGetPMIntegralPage',
    method: 'get',
    params: query,
  })
}
// 小程序-获取党组活动分页列表
export function WeGetMyActivityPage(query) {
  return request({
    url: 'PBActivity/WeGetMyActivityPage',
    method: 'get',
    params: query,
  })
}
// 小程序-获取党组活动分页列表
export function WxGetMyActivityPage(query) {
  return request({
    url: 'PBActivity/WxGetMyActivityPage',
    method: 'get',
    params: query,
  })
}
// 获取资讯信息-党员端
export function WeGetPartyInfo(query) {
  return request({
    url: 'PartyInfo/WeGetPartyInfo',
    method: 'get',
    params: query,
  })
}
// 小程序党建大事件时间轴列表
export function WxGetDateAxisList(query) {
  return request({
    url: 'PartyInfo/WxGetDateAxisList',
    method: 'get',
    params: query,
  })
}
// 居民端-获取我的商铺列表
export function WxGetMyShopList(query) {
  return request({
    url: 'Shop/WxGetMyShopList',
    method: 'get',
    params: query,
  })
}

// 居民端-重新绑定微信
export function WxReBindShop(data) {
  return request({
    url: 'Shop/WxReBindShop',
    method: 'post',
    data,
  })
}

// 居民端-获取我的企业信息列表
export function WxGetMyEnterpriseList(query) {
  return request({
    url: 'Enterprise/WxGetMyEnterpriseList',
    method: 'get',
    params: query,
  })
}
// 居民端-获取单位从业人员列表
export function WxGetEntStaffPage(query) {
  return request({
    url: 'Staff/WxGetEntStaffPage',
    method: 'get',
    params: query,
  })
}
// 居民端-保存从业人员信息
export function WxSaveStaff(data) {
  return request({
    url: 'Staff/WxSaveStaff',
    method: 'post',
    data,
  })
}

// 获取从业人员详情
export function GetStaff(query) {
  return request({
    url: 'Staff/GetStaff',
    method: 'get',
    params: query,
  })
}

// 删除员工信息
export function WxDeleteStaff(data) {
  return request({
    url: 'Staff/WxDeleteStaff',
    method: 'post',
    data,
  })
}
// 居民端-获取我的隔离登记信息列表
export function WxGetIsolationPage(query) {
  return request({
    url: 'Isolation/WxGetIsolationPage',
    method: 'get',
    params: query,
  })
}

// 居民端-我的返洛排查列表
export function WxGetReportingPage(query) {
  return request({
    url: 'Vaccine/WxGetReportingPage',
    method: 'get',
    params: query,
  })
}

// 居民端-我的疫苗排查列表
export function WxGetCheckPage(query) {
  return request({
    url: 'Vaccine/WxGetCheckPage',
    method: 'get',
    params: query,
  })
}

// 居民端-更新疫苗接种状态
export function WxUpdateVaccinateStatus(data) {
  return request({
    url: 'Vaccine/WxUpdateVaccinateStatus',
    method: 'post',
    data,
  })
}

// 居民端-我的返洛排查列表
export function WxGetOutReportingPage(query) {
  return request({
    url: 'Vaccine/WxGetOutReportingPage',
    method: 'get',
    params: query,
  })
}
// 居民端-社区活动分类
export function WeGetPBActivityPage(query) {
  return request({
    url: 'PBActivityKind/WeGetPBActivityPage',
    method: 'get',
    params: query,
  })
}
// 小程序-获取社区活动分页列表
export function WePBGetActivityPage(query) {
  return request({
    url: 'PBActivity/WeGetActivityPage',
    method: 'get',
    params: query,
  })
}

// 获取社区活动详情
export function WeGetPBActivityDetail(AId) {
  return request({
    url: 'system/tactivity/' + AId,
    method: 'get',
  })
}

// 小程序-报名参与社区活动
export function WePBEnrolActivity(data) {
  return request({
    url: 'system/tpbactsignup',
    method: 'post',
    data: data,
  })
}

// 小程序-获取社区资讯分类
export function WeGetInfoKindInfoPage(query) {
  return request({
    url: 'system/tactkind/list',
    method: 'get',
    params: query,
  })
}

// 小程序-发布社区资讯
export function SaveActivity(data) {
  return request({
    url: "system/tactivity/appletSave",
    method: "post",
    data,
  });
}
// 获取资讯信息列表-居民端
export function WePBGetRealInfoPage(query) {
  return request({
    url: 'system/trealinfo/list',
    method: 'get',
    params: query,
  })
}
// 获取社区活动-居民端
export function WePBGetTactivityPage(query) {
  return request({
    url: 'system/tactivity/list',
    method: 'get',
    params: query,
  })
}
// 获取管家风采-居民端
export function WeWorkreportPage(query) {
  return request({
    url: 'system/workreport/list',
    method: 'get',
    params: query,
  })
}
export function WeWorkreportInfo(Id) {
  return request({
    url: 'system/workreport/' + Id,
    method: 'get',
  })
}
// 获取管家风采-居民端
export function taskPage(query) {
  return request({
    url: 'system/tactivity/list',
    method: 'get',
    params: query,
  })
}
// 获取工作动态-居民端
export function GetDynamicPage(query) {
  return request({
    url: 'system/dynamic/list',
    method: 'get',
    params: query,
  })
}
// 获取工作动态详情
export function WeGetDynamicDetail(id) {
  return request({
    url: 'system/dynamic/' + id,
    method: 'get',
  })
}

// 小程序-发布工作动态
export function SaveDynamic(data) {
  return request({
    url: "system/dynamic",
    method: "post",
    data,
  });
}

// 获取居民来稿-居民端
export function GetSubmissionsPage(query) {
  return request({
    url: 'system/submissions/list',
    method: 'get',
    params: query,
  })
}
// 获取居民来稿详情
export function WeGetSubmissionsDetail(id) {
  return request({
    url: 'system/submissions/' + id,
    method: 'get',
  })
}

// 小程序-发布居民来稿
export function SaveSubmissions(data) {
  return request({
    url: "system/submissions",
    method: "post",
    data,
  });
}

// 发布活动记录【党建小程序使用】
export function WeRecActLogs(data) {
  return request({
    url: 'system/tactlog',
    method: 'post',
    data: data,
  })
}

// 获取党组活动详情
export function WeGetActivityDetailPB(query) {
  return request({
    url: 'PBActivity/WeGetActivityDetail',
    method: 'get',
    params: query,
  })
}
// 获取商品分页列表
export function WxGetMyGoodsPage(query) {
  return request({
    url: 'Goods/WxGetMyGoodsPage',
    method: 'get',
    params: query,
  })
}
// 获取商品详情
export function WxGetMyGoods(query) {
  return request({
    url: 'Goods/WxGetMyGoods',
    method: 'get',
    params: query,
  })
}

// 场所端-获取美食详情
export function WxGetMyFood(id) {
  return request({
    url: 'system/food/' + id,
    method: 'get',
  })
}
// 获取商品列表
export function WxGetGoodsPage(query) {
  return request({
    url: 'Goods/WxGetGoodsPage',
    method: 'get',
    params: query,
  })
}

// 获取商品详情
export function WxGetGoods(query) {
  return request({
    url: 'Goods/WxGetGoods',
    method: 'get',
    params: query,
  })
}

// 保存商品
export function WxMySaveGoodsSort(data) {
  return request({
    url: 'Goods/WxMySaveGoodsSort',
    method: 'post',
    data: data,
  })
}
// 删除商品
export function WxMyDeleteGoods(data) {
  return request({
    url: 'Goods/WxMyDeleteGoods',
    method: 'post',
    data: data,
  })
}

// 场所端-保存美食
export function WxSaveMyFood(data) {
  return request({
    url: 'system/food',
    method: 'post',
    data: data,
  })
}
// 获取商品类别列表
export function WxGetGoodsCateList(query) {
  return request({
    url: 'GoodsCate/WxGetGoodsCateList',
    method: 'get',
    params: query,
  })
}

// 获取商品分类列表
export function WxGetGoodsSortList(query) {
  return request({
    url: 'GoodsSort/WxGetGoodsSortList',
    method: 'get',
    params: query,
  })
}

// 获取商品分类列表
export function WxGetMyGoodsSortList(query) {
  return request({
    url: 'GoodsSort/WxGetMyGoodsSortList',
    method: 'get',
    params: query,
  })
}
// 保存商品分类
export function WxSaveGoodsSort(data) {
  return request({
    url: 'GoodsSort/WxSaveGoodsSort',
    method: 'post',
    data: data,
  })
}

// 删除商品
export function WxDeleteGoodsSort(data) {
  return request({
    url: 'GoodsSort/WxDeleteGoodsSort',
    method: 'post',
    data: data,
  })
}

// 场所端-删除食品分类
export function WxDeleteFoodCate(id) {
  return request({
    url: 'system/foodcate/' + id,
    method: 'delete',
  })
}
// 获取商品分类详情
export function WxGetMyGoodsSort(query) {
  return request({
    url: 'GoodsSort/WxGetMyGoodsSort',
    method: 'get',
    params: query,
  })
}

// 获取商品订单
export function WxGetShopOrderPage(query) {
  return request({
    url: 'ShopOrder/WxGetShopOrderPage',
    method: 'get',
    params: query,
  })
}

// 接收订单，居民端商铺使用
export function WxRecviceOrder(data) {
  return request({
    url: 'ShopOrder/WxRecviceOrder',
    method: 'post',
    data: data,
  })
}

// 场所端-接收订单
export function WxRecviceMessOrder(data) {
  return request({
    url: 'system/messorder/receiveOrder',
    method: 'post',
    data: data,
  })
}

// 结单，居民端商铺使用
export function WxFinishOrder(data) {
  return request({
    url: 'ShopOrder/WxFinishOrder',
    method: 'post',
    data: data,
  })
}

// 场所端-结单
export function WxFinishMessOrder(data) {
  return request({
    url: 'system/messorder/finishOrder',
    method: 'post',
    data: data,
  })
}

export function GetActivityPage(query) {
  return request({
    url: 'PBActivity/GetActivityPage',
    method: 'get',
    params: query,
  })
}
// 获取七牛云token
export function UploadQiniuUpToken(data) {
  return request({
    url: 'UploadFile/UploadQiniuUpToken',
    method: 'post',
    data,
  })
}
//七牛云视频上传
export function UploadQiniuVideo(data) {
  return request({
    url: 'UploadFile/UploadQiniuVideo',
    method: 'post',
    data,
  })
}
// 获取促销活动列表-商家
export function WxGetMyPromotionPage(query) {
  return request({
    url: 'Promotion/WxGetMyPromotionPage',
    method: 'get',
    params: query,
  })
}
// 获取促销活动详情-商家
export function WxGetMyPromotion(query) {
  return request({
    url: 'Promotion/WxGetMyPromotion',
    method: 'get',
    params: query,
  })
}
// 保存促销活动-商铺
export function WxSaveMyPromotion(data) {
  return request({
    url: 'Promotion/WxSaveMyPromotion',
    method: 'post',
    data,
  })
}

// 删除促销活动
export function WxDeleteMyPromotion(data) {
  return request({
    url: 'Promotion/WxDeleteMyPromotion',
    method: 'post',
    data,
  })
}

// 获取促销活动详情-居民
export function WxGetPromotion(query) {
  return request({
    url: 'Promotion/WxGetPromotion',
    method: 'get',
    params: query,
  })
}

// 参加促销活动-居民
export function WxEnrolPromotion(data) {
  return request({
    url: 'Promotion/WxEnrolPromotion',
    method: 'post',
    data,
  })
}

// 获取我的促销活动报名列表
export function WxGetActEnrolPage(query) {
  return request({
    url: 'Promotion/WxGetActEnrolPage',
    method: 'get',
    params: query,
  })
}

// 获取促销活动报名列表
export function WxGetMyActEnrolPage(query) {
  return request({
    url: 'Promotion/WxGetMyActEnrolPage',
    method: 'get',
    params: query,
  })
}

// 获取核酸检测报备信息列表
export function WxGetNATestPage(query) {
  return request({
    url: 'NATest/WxGetNATestPage',
    method: 'get',
    params: query,
  })
}
// 获取会员信息
export function WeGetMemberByOpenID(query) {
  return request({
    url: 'Member/WeGetMemberByOpenID',
    method: 'get',
    params: query,
  })
}
// 获取公众号文章列表
export function WxGetWxArticlePage(query) {
  return request({
    url: 'WxArticle/WxGetWxArticlePage',
    method: 'get',
    params: query,
  })
}
// 获取公众号文章详情
export function WxGetWxArticle(query) {
  return request({
    url: 'WxArticle/WxGetWxArticle',
    method: 'get',
    params: query,
  })
}

// 通过OpenId获取会员详情
export function WeMyMemberInfo(query) {
  return request({
    url: 'system/tmember/login',
    method: 'get',
    params: query,
  })
}

// 获取邻里中心 详情
export function WxGetNeInfoOfOrgan(query) {
  return request({
    url: 'system/neinfo/list',
    method: 'get',
    params: query,
  })
}

// 获取邻里中心 详情
export function WxGetNeInfo(id) {
  return request({
    url: 'system/neinfo/' + id,
    method: 'get',
  })
}

// 获取商铺类型列表
export function WxGetShopTypeList(query) {
  return request({
    url: 'Shop/WxGetShopTypeList',
    method: 'get',
    params: query,
  })
}

// 获取商铺类型列表
export function WxGetShopPage(query) {
  return request({
    url: 'Shop/WxGetBankPage',
    method: 'get',
    params: query,
  })
}

// 商城端-获取我的商城列表
export function WxGetMyBankList(query) {
  return request({
    url: 'Shop/WxGetMyBankList',
    method: 'get',
    params: query,
  })
}
// 评价服务订单
export function WeEvaluateOrder(data) {
  return request({
    url: 'OrderEval/WeEvaluateOrder',
    method: 'post',
    data,
  })
}

// 居民端-评价食堂订单
export function WxEvaluateOrder(data) {
  return request({
    url: 'system/preeval',
    method: 'post',
    data,
  })
}
export function WxMessordereval(data) {
  return request({
    url: 'system/messordereval',
    method: 'post',
    data,
  })
}
// 获取商品订单
export function WeGetMyOrderPage(query) {
  return request({
    url: 'ShopOrder/WeGetMyOrderPage',
    method: 'get',
    params: query,
  })
}

// 场所端-获取食堂订单列表
export function WxGetOrderPage(query) {
  return request({
    url: 'MessOrder/WxGetOrderPage',
    method: 'get',
    params: query,
  })
}

// 居民端-获取我的订单列表
export function WxGetMyOrderPage(query) {
  return request({
    url: 'system/messorder/list',
    method: 'get',
    params: query,
  })
}
// 商城端-获取我的商城详情
export function WxGetBank(query) {
  return request({
    url: 'Shop/WxGetBank',
    method: 'get',
    params: query,
  })
}

// 居民端-获取指定邻里中心的场所列表分页列表
export function WxGetFnRoomPage(params) {
  return request({
    url: 'system/fnroom/list',
    method: 'get',
    params,
  })
}

// 居民端-获取指定邻里中心的房源分页列表
export function WxGetLeasePage(params) {
  return request({
    url: 'system/lease/list',
    method: 'get',
    params
  })
}

export function WxGetFoodCateList(params) {
  return request({
    url: 'system/foodcate/list',
    method: 'get',
    params,
  })
}

// 居民端-获取美食列表
export function WxGetFoodPage(params) {
  return request({
    url: 'system/food/list/',
    method: 'get',
    params,
  })
}

// 居民端-获取美食详情
export function WxGetFood(id) {
  return request({
    url: 'system/food/' + id,
    method: 'get',
  })
}

// 居民端-获取我的房源详情
export function WxGetLease(id) {
  return request({
    url: 'system/lease/' + id,
    method: 'get',
  })
}

// 食堂端-获取我的食堂列表
export function WxGetMyFnRoomList(query) {
  return request({
    url: 'system/fnroom/list',
    method: 'get',
    params: query,
  })
}

// 场所端-获取美食列表
export function WxGetMyFoodPage(query) {
  return request({
    url: 'system/food/list',
    method: 'get',
    params: query,
  })
}

// 场所端-删除美食
export function WxDeleteMyFood(id) {
  return request({
    url: 'system/food/' + id,
    method: 'delete',
  })
}

// 获取美食分类列表
export function WxGetMyFoodCateList(query) {
  return request({
    url: 'system/foodcate/list',
    method: 'get',
    params: query,
  })
}

// 场所端-保存食品分类
export function WxSaveFoodCate(data) {
  return request({
    url: 'system/foodcate',
    method: 'post',
    data,
  })
}

// 场所端-获取食品分类详情
export function WxGetMyFoodCate(id) {
  return request({
    url: 'system/foodcate/' + id,
    method: 'get',
  })
}

// 获取党建活动风采（台账）分页列表
export function WxGetPbActElegantPage(query) {
  return request({
    url: 'system/tactelegant/list',
    method: 'get',
    params: query,
  })
}
// 保存活动风采（台账）
export function SaveElegantPage(data) {
  return request({
    url: 'system/tactelegant/appletSave',
    method: 'post',
    data,
  })
}
// 获取党建活动风采详情
export function WxGetPbActElegantDetail(AEId) {
  return request({
    url: 'system/tactelegant/' + AEId,
    method: 'get',
  })
}
// 居民端-预订入住
export function WxPreHotel(data) {
  return request({
    url: 'PreHotel/Wx_PreHotel',
    method: 'post',
    data,
  })
}

// 居民端-获取房间详情
export function WxGetRoomType(query) {
  return request({
    url: 'RoomType/Wx_GetRoomType',
    method: 'get',
    params: query,
  })
}

// 居民端-获取房间详情
export function WxGetHRoomTypeList(query) {
  return request({
    url: 'RoomType/Wx_GetHRoomTypeList',
    method: 'get',
    params: query,
  })
}

// 房主端-设置订单入住状态
export function HSetLiveStatus(data) {
  return request({
    url: 'PreHotel/H_SetLiveStatus',
    method: 'post',
    data,
  })
}

// 民宿旅馆-保存房间类型信息
export function HSaveRoomType(data) {
  return request({
    url: 'RoomType/H_SaveRoomType',
    method: 'post',
    data,
  })
}

// 民宿旅馆-保存从业人员信息
export function HSaveHotelStaff(data) {
  return request({
    url: 'HotelStaffStaff/H_SaveHotelStaff',
    method: 'post',
    data,
  })
}

// 民宿旅馆-保存房间信息
export function HSaveHotelRoom(data) {
  return request({
    url: 'HotelRoom/H_SaveHotelRoom',
    method: 'post',
    data,
  })
}

// 民宿旅馆-保存旅客信息
export function HSaveGuest(data) {
  return request({
    url: 'Guest/H_SaveGuest',
    method: 'post',
    data,
  })
}

// 民宿旅馆-离职
export function HLeaveDate(data) {
  return request({
    url: 'HotelStaffStaff/H_LeaveDate',
    method: 'post',
    data,
  })
}

// 房主端-确认入住订单
export function HConfirmPreHotel(data) {
  return request({
    url: 'PreHotel/H_ConfirmPreHotel',
    method: 'post',
    data,
  })
}

// 民宿旅馆-重新入职
export function HInDate(data) {
  return request({
    url: 'HotelStaffStaff/H_InDate',
    method: 'post',
    data,
  })
}
// 民宿旅馆-获取我的房间类型列表，主要用于房间类型管理
export function HGetMyRoomTypeList(query) {
  return request({
    url: 'RoomType/H_GetMyRoomTypeList',
    method: 'get',
    params: query,
  })
}

// 居民端-获取从业人员详情
export function HGetMyHotelStaff(query) {
  return request({
    url: 'HotelStaffStaff/H_GetMyHotelStaff',
    method: 'get',
    params: query,
  })
}

// 居民端-获取房间详情
export function HGetMyHotelRoom(query) {
  return request({
    url: 'HotelRoom/H_GetMyHotelRoom',
    method: 'get',
    params: query,
  })
}

// 居民端-获取民宿旅馆详情
export function HGetMyHotel(query) {
  return request({
    url: 'Hotel/H_GetMyHotel',
    method: 'get',
    params: query,
  })
}

// 民宿旅馆-获取旅客详情
export function HGetMyGuest(query) {
  return request({
    url: 'Guest/H_GetMyGuest',
    method: 'get',
    params: query,
  })
}

// 民宿旅馆-删除从业人员
export function HDeleteHotelStaff(data) {
  return request({
    url: 'HotelStaffStaff/H_DeleteHotelStaff',
    method: 'post',
    data,
  })
}

// 游客-根据入住时间获取房间当前的单价
export function Wx_GetHotelRoomPrice(query) {
  return request({
    url: 'system/room/getPriceByTime',
    method: 'get',
    params: query,
  })
}

// 游客-获取房间详情
export function Wx_GetHotelRoom(query) {
  return request({
    url: `system/room/${query}`,
    method: 'get',
  })
}

// 居民端-获取民宿旅馆照片
export function Wx_GetHotelImgs(query) {
  return request({
    url: 'Hotel/Wx_GetHotelImgs',
    method: 'get',
    params: query,
  })
}

// 游客端-计算预订费用
export function Wx_CalculatePreAmount(data) {
  return request({
    url: 'system/prehotel/dayCount',
    method: 'post',
    data: data,
  })
}

// 获取民宿活动
export function WeTrealinfoPage(query) {
  return request({
    url: 'system/trealinfo/list',
    method: 'get',
    params: query,
  })
}

// 获取民宿活动分类
export function WeTinfokindPage(query) {
  return request({
    url: 'system/tinfokind/list',
    method: 'get',
    params: query,
  })
}


// 居民端-获取我的预约单列表
export function WxGetMyPreBookPage(query) {
  return request({
    url: 'system/prebook/list',
    method: 'get',
    params: query,
  })
}
// 居民端-接单
export function wxReceiveOrder(data) {
  return request({
    url: 'system/prebook/receive',
    method: 'post',
    data,
  })
}
// 居民端-完成
export function wxSuccessOrder(data) {
  return request({
    url: 'system/prebook/finish',
    method: 'post',
    data,
  })
}
// 居民端-撤销预约
export function WxRevokePreBook(data) {
  return request({
    url: 'system/prebook/revoke',
    method: 'post',
    data,
  })
}
// 居民端-拒绝
export function getRejectOrder(data) {
  return request({
    url: 'system/prebook/reject',
    method: 'post',
    data,
  })
}
// 居民端-删除预约单
export function WxDeletePreBook(id) {
  return request({
    url: 'system/prebook/' + id,
    method: 'delete',
  })
}
// 看房预约
export function WxPreRoom(data) {
  return request({
    url: 'system/preroom/preRoom',
    method: 'post',
    data,
  })
}

// 居民端-获取我的看房预约单列表
export function WxGetMyPreRoomPage(params) {
  return request({
    url: 'system/preroom/list',
    method: 'get',
    params,
  })
}

// 居民端-删除看房预约单
export function WxDeletePreRoom(id) {
  return request({
    url: 'system/preroom/' + id,
    method: 'delete',
  })
}


// 居民端-撤销订单
export function WxRevokeOrder(data) {
  return request({
    url: 'system/messorder/revokeOrder',
    method: 'post',
    data,
  })
}

// 居民端-删除订单
export function WxDeleteOrder(id) {
  return request({
    url: 'system/messorder/' + id,
    method: 'delete',
  })
}

// 房主端-获取我的房源
export function WxGetMyLeaseList(query) {
  return request({
    url: 'system/lease/list',
    method: 'get',
    params: query,
  })
}

// 房主端-保存我的房源信息，用于新增或修改房源
export function WxSaveMyLease(data) {
  return request({
    url: 'system/lease',
    method: 'post',
    data,
  })
}


// 房主端-获取指定房源的预约单列表
export function WxGetPreRoomPage(params) {
  return request({
    url: 'system/preroom/list',
    method: 'get',
    params,
  })
}
// 房主端-保存我的房源信息，用于处理房源
export function WxDealOrder(data) {
  return request({
    url: 'system/preroom/dealOrder',
    method: 'post',
    data,
  })
}

// 获取弹窗广告
export function appletList(data) {
  return request({
    url: 'system/silde/appletList',
    method: 'post',
    data,
  })
}

// 页面停留20s积分加2
export function addJf(data){
  return request({
    url:"system/integral",
    method:"post",
    data,
})
}

// 查询房源类型列表
export function listType() {
  return request({
    url: '/system/neighbor/type/list/all',
    method: 'get',
  })
}


// 查询房源类型列表
export function getType() {
  return request({
    url: '/system/neighbor/type/list',
    method: 'get',
  })
}

